module.exports = __webpack_public_path__ + "img/trash-outline-pink.d01905c2.svg";